import { composeRefs } from "@tamagui/compose-refs";
import { isTamaguiComponent, useEvent } from "@tamagui/web";
import { forwardRef, useCallback, useEffect, useRef } from "react";
import { registerFocusable } from "./registerFocusable";
function focusableInputHOC(Component) {
  const component = Component.extractable(
    forwardRef(
      (props, ref) => {
        const isInput = isTamaguiComponent(Component) && Component.staticConfig.isInput;
        const inputValue = useRef(props.value || props.defaultValue || "");
        const unregisterFocusable = useRef();
        const inputRef = useCallback(
          (input) => {
            if (!props.id)
              return;
            if (!input)
              return;
            unregisterFocusable.current?.();
            unregisterFocusable.current = registerFocusable(props.id, {
              focus: input.focus,
              ...isInput && {
                // react-native doesn't support programmatic .select()
                focusAndSelect() {
                  input.focus();
                  if (input.setSelection && typeof inputValue.current === "string") {
                    input.setSelection(0, inputValue.current.length);
                  }
                }
              }
            });
          },
          [isInput, props.id]
        );
        const combinedRefs = composeRefs(ref, inputRef);
        useEffect(() => {
          return () => {
            unregisterFocusable.current?.();
          };
        }, []);
        const onChangeText = useEvent((value) => {
          inputValue.current = value;
          props.onChangeText?.(value);
        });
        const finalProps = isInput ? {
          ...props,
          onChangeText
        } : props;
        return <Component ref={combinedRefs} {...finalProps} />;
      }
    )
  );
  return component;
}
export {
  focusableInputHOC
};
//# sourceMappingURL=focusableInputHOC.js.map
